import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class WeatherStationService {
  private apiUrl = environment.apiAdminBaseUrl + 'weather-station/check';

  constructor(private http: HttpClient) { }

  hasTenantWeatherStation(tenantId: number): Observable<boolean> {
    const params = new HttpParams().set('tenantId', tenantId.toString());
    return this.http.get<boolean>(this.apiUrl, { params });
  }
}
